module.exports = __webpack_public_path__ + "static/media/graphic-1.ae6230a2.png";